// 基础设置 --- 分析规则设置
import request from '../request.js'

// 分析规则 分页查询 --- 叶凡
export const getBillRules = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'billRule/getBillRules',
    })
}

// 保存/更新分析规则 --- 叶凡
export const saveOrUpdateRule = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'billRule/saveBillRule',
    })
}

// 规则操作接口 --- 叶凡
/**
 * 
 * @param {type, id} params 
 * @returns 
 * type
    1: 删除
    2：启用/禁用（此操作多一个请求参数 status 0:禁用  1：启用）
    3：设置默认操作
 */
export const ruleTools = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'billRule/updateStatus',
    })
}